import PartnersActionTypes from './partners.types';

export const setPartners = (partners) => ({
  type: PartnersActionTypes.SET_PARTNERS,
  payload: partners,
});
